import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';

export abstract class AtxGenericFormComponent implements OnInit {
    protected form: FormGroup;

    constructor(
        private readonly formBuild: FormBuilder,
        private readonly validationError: ValidationErrors,
    ) {}

    public ngOnInit() {
        this.setValidators();

        this.form = this.formBuild.group(this.validationError);
    }

    private setValidators() {
        for (const element in this.validationError) {
            this.checkOtherValidation(element);
        }
    }

    private checkOtherValidation(element) {
        if (this.validationError[element].other) {
            this.validationError[element] = this.formBuild.group(this.validationError[element].other);
        }
    }
}
